import { useState } from "react";
import styles from "./styles.module.scss";
import { FieldGroup, FormCard } from "../../reusable";

import { FormPartInterface } from "../../../interfaces";
export const Complete = (props: FormPartInterface) => {
  const { isActive } = props;
  const [currentStep, setCurrentStep] = useState(0);
  const [postCurrentStep, setPostCurrentStep] = useState(0);

  const getCurrentStep = () => {
    return isActive == "complete" ? (
      <FieldGroup title="Claim Complete">
        <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
          <h2 style={{ textAlign: "center" }}>Thank you!</h2>
          <p className={styles.tagline}>
            We are currently compiling evidence and your feedback is
            appreciated. We will be in touch with further information once we
            have concluded our survey.
          </p>
        </FormCard>
      </FieldGroup>
    ) : (
      <></>
    );
  };

  return getCurrentStep();
};
